import moment from 'moment';
import React, { FC } from 'react';

import { JDatePicker } from '../../../JForm/JDatePicker';
import { isFormattableDate } from '../../utils';
import { useCompositorContext } from '../CompositorProvider';
import { FormItem } from '../FormItem';
import { JDateProps } from './../../models';

export const JDateTime: FC<JDateProps> = (props) => {
    const { formatDate, formatDateTime } = useCompositorContext()
    const format = props.showTime ? formatDateTime : formatDate
    const value = isFormattableDate(props.value as string) ? moment(props.value) : ''
    
    return (
        <FormItem fieldProps={props} initialValue={value}>
            <JDatePicker
                defaultValue={value}
                name={props.name}
                minDate={props.minDate}
                maxDate={props.maxDate}
                disabled={props.disabled}
                showTime={props.showTime}
                placeholder={props.placeholder}
                format={props.format ?? format}
                errorMessage={props.validationMessage}
            />
        </FormItem>
    )
}